import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import packageInfo from '../../../../../../package.json';

@Component({
  selector: 'app-terminal-debug-tab',
  templateUrl: './terminal-debug-tab.component.html',
  styleUrls: ['./terminal-debug-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatExpansionModule],
})
export class TerminalDebugTabComponent {
  readonly appVersion = packageInfo.version;
}
